/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./transformersEdit.vue?vue&type=template&id=5ca915f4&scoped=true"
import script from "./transformersEdit.vue?vue&type=script&lang=js"
export * from "./transformersEdit.vue?vue&type=script&lang=js"
import style0 from "./transformersEdit.vue?vue&type=style&index=0&id=5ca915f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca915f4",
  null
  
)

export default component.exports